// 静态页面模拟图4
import * as React from 'react';

export default () => (
  <div>
    <h1>Customer Service</h1>
  </div>
);
